export default __webpack_public_path__ + "static/media/jacob.6dc1c03b.png";